import React, {Component} from 'react';
import TextField from '@material-ui/core/TextField';
import { withStyles} from '@material-ui/core/styles';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MenuItem from "@material-ui/core/MenuItem";
import styles from '../../Assets/CSS/stylesheet_UHS'
import {Select} from "@material-ui/core";

const CustomTextField = withStyles(
    styles.textField
)(TextField);

class CommonDropDwn extends Component{
    constructor(props) {
        super(props);
        this.state={value : '', errorText:this.props.helperMsg, isValid : false}

    }
    setValue=(event)=>{
        let txtVal = event && event.target ? event.target.value : event;
        if (txtVal == null) {
            txtVal = '';
        }
        txtVal = typeof txtVal === 'string'
            ? (typeof txtVal.trimLeft === 'function' ? txtVal.trimLeft() : txtVal.trim())
            : String(txtVal);
        this.setState({errorText:'', value : txtVal, isValid : false});
        this.props.setChild(txtVal, true, this.props.parentDetails);
    }


    render() {
        return (
            <CustomTextField
                select
                required={this.props.reqFlag}
                label={this.props.label}
                name={this.props.name}
                value={this.props.value}
                onChange={this.setValue}
                style={styles.dropDown}
                helperText= {(this.props.value === '' || this.state.isValid) ? this.state.errorText:''}
                error={this.state.isValid}
                variant="filled"
                SelectProps={{
                    MenuProps: {
                        getContentAnchorEl: null,
                        anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                        transformOrigin: { vertical: 'top', horizontal: 'left' },
                    },
                }}
                disabled={this.props.disable}>
                {(this.props.List || []).map((option, index) => {
                    const optValue = typeof option === 'object' && option !== null
                        ? (option.value != null ? option.value : option.key)
                        : option;
                    const optKey = typeof option === 'object' && option !== null
                        ? (option.key != null ? option.key : option.value)
                        : option;
                    return (
                        <MenuItem key={index} value={optValue}>
                            {optKey}
                        </MenuItem>
                    );
                })}
            </CustomTextField>

        );
    }
}

export default CommonDropDwn;


